/* eslint-disable react-hooks/exhaustive-deps */

import App from '../../layout/App';
import {
  FormContent, Container, BoxInput,
  Message, Box,
  Select, Option,
  TitleFieldForm, TextLabel, Madatory,
  ContentBoxColumn,
  TextSpan,
  BoxColumnRow
} from '../../styles/styles'
import React, { useContext, useEffect, useState } from 'react';
import InputResponsive1 from '../../Components/InputResponsive1';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api'
import apiAux from '../../utils/apiAux';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Loading from '../../Components/Loading';
import { onlyNumber } from '../../utils/mask';
import { cepMask } from '../../utils/mask'
import MessagePopUp from '../../Components/messagePopUp';
import { ClearMask } from '../../utils/mask';
import InfoForm from '../../Components/infoForm'
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { MessageContext } from '../../context/message';
import { validationForm2 } from '../../utils/validationStudent';
import { useIndexedLabels } from '../../utils/useIndexedLabels';

function DadosPessoais() {
  const {
    getTitleIndex,
    getIndexByLabel,
  } = useIndexedLabels();
  const [messageRequired, setMessageRequired] = useState([])
  const [removeLoad, setRemoveLoad] = useState(true)
  const { setErrorMessage } = useContext(MessageContext);
  const [CityDetails, setCityDetails] = useState(null)
  const [DadosPessoais, setDadosPessoais] = useState()

  let currentIndex = JSON.parse(sessionStorage.getItem('quantCurrentIndexFields')) || 0

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(validationForm2)
  });


  const navigate = useNavigate()

  const onSubmit = async (data) => {
    let dados = DadosPessoais
    sessionStorage.setItem('AlunoEditar', JSON.stringify(dados))
    sessionStorage.setItem('quantCurrentIndexFields', JSON.stringify(currentIndex))
    setRemoveLoad(false)

    setTimeout(function () {
      if (sessionStorage.getItem('AlunoEditar') !== '' || sessionStorage.getItem('AlunoEditar') !== undefined) {
        setRemoveLoad(true)
        navigate('/aluno/editar-organizacao')
      }
      else {
        setRemoveLoad(true)
      }
    }, 1000);

  }



  useEffect(() => {

    let Aluno = JSON.parse(sessionStorage.getItem('AlunoEditar'))
    setDadosPessoais(Aluno)
  }, [])

  useEffect(() => {
    // api.get("/resource/city/list").then((response) => {
    //   setlistCountrys(response.data)
    // })
    api.get('/resource/city/list-by-uf')
      .then(function (response) {

      }).catch((err) => {
        setErrorMessage([{ message: "Erro ao buscar dados auxiliares", ok: false }])
      })
  }, [])

  useEffect(() => {
    let test = ClearMask(DadosPessoais?.cep)
    if (test?.length === 8) {
      apiAux.get(test + '/json/').then(function (response) {
        setCityDetails(response.data)
        setDadosPessoais({
          ...DadosPessoais, cityResidence: response.data.ibge
        })
      }).catch((err) => {
      })
    }
  }, [DadosPessoais?.cep])
  useEffect(() => {
  }, [])

  useEffect(() => {
    if (errors) {
      const entries = Object.entries(errors).map(([key, error]) => ({
        id: key + '-' + error.message,
        fieldName: key,
        error,
      }));
      setMessageRequired(entries);
    }
  }, [errors]);

  console.log('CityDetails?.uf', CityDetails?.uf);
  return (
    <>
      {!removeLoad && <Loading />}
      <div className='span-message'>
        {messageRequired.map(({ id, fieldName, error }) => {
          const idx = getIndexByLabel(fieldName) || "";
          const text = error.message;

          return (
            <MessagePopUp
              key={id}
              title={`Campo ${idx} - obrigatório`}
              text={text}
              onClose={() =>
                setMessageRequired(prev => prev.filter(m => m.id !== id))
              }
            />
          );
        })}
      </div>
      <App>
        <Container>
          <InfoForm
            title="Aluno"
            wasChanged={DadosPessoais?.wasChanged}
            subtitle="Dados Pessoais"
            positionPagination="2/3"
          />
          <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
            <FormContent>
              <BoxInput>
                <InputResponsive1
                  title={getTitleIndex('Número da matricula da certidão de nascimento (certidão nova)', 'birthCertificateRegistration')}
                  name='birthCertificateRegistration'
                  maxlength='32'
                  value={onlyNumber(DadosPessoais?.birthCertificateRegistration)}
                  {...setValue('birthCertificateRegistration', DadosPessoais?.birthCertificateRegistration)}
                  register={register('birthCertificateRegistration')}
                  onChange={e => setDadosPessoais({ ...DadosPessoais, birthCertificateRegistration: e.target.value })}
                  erro={errors.birthCertificateRegistration?.message}
                />
              </BoxInput>

            </FormContent>
            <FormContent style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
              <Box>
                <TextLabel>
                  Endereço residencial
                </TextLabel>
                <TitleFieldForm>
                  {getTitleIndex('Pais de residência', 'contryResidence')} <Madatory>*</Madatory>
                </TitleFieldForm>
                <Select
                  name='countryResidence'
                  {...register('contryResidence')}
                  {...setValue('countryResidence', DadosPessoais?.countryResidence ?? 0)}
                  value={DadosPessoais?.countryResidence || 0}
                  onChange={e => setDadosPessoais({ ...DadosPessoais, countryResidence: Number(e.target.value) })}>
                  <Option value={0} disabled hidden>selecione</Option>
                  <Option value={32}>Argentina</Option>
                  <Option value={68}>Bolívia</Option>
                  <Option value={76}>Brasil</Option>
                  <Option value={170}>Colômbia</Option>
                  <Option value={328}>Guiana</Option>
                  <Option value={254}>Guiana Francesa</Option>
                  <Option value={600}>Paraguai</Option>
                  <Option value={604}>Peru</Option>
                  <Option value={740}>Suriname</Option>
                  <Option value={604}>Uruguai</Option>
                  <Option value={604}>Venezuela</Option>
                </Select>
                <Message>{errors.countryResidence?.message}</Message>
              </Box>
              <Box style={{ display: DadosPessoais?.countryResidence?.length || 0 ? '' : DadosPessoais?.countryResidence === 76 ? 'flex' : 'none' }}>
                <InputResponsive1
                  className='cep'
                  title={getTitleIndex('CEP', 'cep', DadosPessoais?.countryResidence === 76)}
                  name='cep'
                  id='cep'
                  maxlength={9}
                  style={{ width: '20%' }}
                  setValue={setValue('cep', cepMask(DadosPessoais?.cep) ?? '')}
                  value={cepMask(DadosPessoais?.cep) || ''}
                  register={register('cep')}
                  erro={errors.cep?.message}
                  onChange={e => setDadosPessoais({ ...DadosPessoais, cep: e.target.value })}
                />

              </Box>
              <BoxColumnRow style={{ display: DadosPessoais?.countryResidence?.length || 0 ? '' : DadosPessoais?.countryResidence === 76 && DadosPessoais?.cep?.length === 9 ? 'flex' : 'none' }}>
                <ContentBoxColumn style={{ display: CityDetails?.uf !== null && CityDetails?.uf !== undefined ? 'flex' : 'none' }}>
                  <TitleFieldForm>
                    UF:
                  </TitleFieldForm>
                  <TextSpan>
                    {CityDetails?.uf}
                  </TextSpan>
                </ContentBoxColumn>
                <ContentBoxColumn style={{ display: DadosPessoais?.cityResidence !== null && DadosPessoais?.cityResidence !== undefined ? 'flex' : 'none' }}>
                  <TitleFieldForm>
                    Município:
                  </TitleFieldForm>
                  <TextSpan>
                    {CityDetails?.localidade || ''}
                  </TextSpan>
                </ContentBoxColumn>
                <ContentBoxColumn style={{ display: CityDetails?.erro === "true" ? 'flex' : 'none' }}>
                  <Message>
                    Verifique o CEP informado, não foi possível encontrar a cidade.
                  </Message>
                </ContentBoxColumn>
              </BoxColumnRow>

              <BoxInput>
                <TitleFieldForm>
                  {getTitleIndex('Localização/ Zona de residência', 'areaResidence')}
                </TitleFieldForm>
                <Box>
                  <Select
                    value={DadosPessoais?.areaResidence || 0}
                    name='areaResidence'
                    {...register('areaResidence')}
                    {...setValue('areaResidence', DadosPessoais?.areaResidence)}
                    onChange={e => setDadosPessoais({ ...DadosPessoais, areaResidence: Number(e.target.value) })}
                  >
                    <Option value={0} disabled hidden>selecione</Option>
                    <Option value={1} > Urbana</Option>
                    <Option value={2}> Rural</Option>
                  </Select>
                  <Message>{errors.areaResidence?.message}</Message>
                </Box>
              </BoxInput>
              <BoxInput>
                <TitleFieldForm>
                  {getTitleIndex('Localização diferenciada de residência', 'differentiatedLocation')}
                </TitleFieldForm>
                <Box>
                  <Select
                    name='differentiatedLocation'
                    {...register('differentiatedLocation')}
                    {...setValue('differentiatedLocation', DadosPessoais?.differentiatedLocation)}
                    value={DadosPessoais?.differentiatedLocation || 0}
                    onChange={e => setDadosPessoais({ ...DadosPessoais, differentiatedLocation: Number(e.target.value) })}>
                    <Option value={0} disabled hidden>selecione</Option>
                    <Option value={1}>Área de assentamento</Option>
                    <Option value={2}>Terra indígena</Option>
                    <Option value={3}>Área onde se localiza comunidade remanescente de quilombolas</Option>
                    <Option value={7}>Não está em localizacão diferenciada</Option>
                  </Select>
                  <Message>{errors.differentiatedLocation?.message}</Message>
                </Box>
              </BoxInput>
            </FormContent>
            <ButtonFormFooter
              textNext="Próximo"
              linkBack={"/aluno/editar-identificacao"}
            />
          </form>
        </Container>
      </App>
    </>
  )

}
export default DadosPessoais;